import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { HslaColor, HslColor, HslColorPicker } from 'react-colorful';
import styled from 'styled-components';
import { token } from '@bynder/design-system';

type Props = {
    defaultValue: HslColor | HslaColor;
    onChange: (color: HslColor) => void;
};

export type SaturationRef = {
    setHueSaturationLightness: (value: HslColor) => void;
};

export const Saturation = forwardRef<SaturationRef, Props>((props, ref) => {
    const [color, setColor] = useState<HslColor | HslaColor>(props.defaultValue);
    const tmpValue = useRef<HslColor | HslaColor>(props.defaultValue);

    useImperativeHandle(
        ref,
        () => ({
            setHueSaturationLightness(value: HslColor) {
                tmpValue.current = { ...tmpValue.current, ...value };
                setColor(tmpValue.current);
            },
        }),
        [],
    );

    function handleChange(newColor: HslColor) {
        tmpValue.current = newColor;
        props.onChange(newColor);
    }

    return <SaturationPicker key={color.h} color={color} onChange={handleChange} />;
});

const SaturationPicker = styled(HslColorPicker)`
    .react-colorful__saturation {
        height: 156px;
        margin-bottom: ${token.spacing6};
        border-bottom: none;
        border-radius: ${token.radiusBase} ${token.radiusBase} 0 0;
        box-shadow: none;
    }

    .react-colorful__hue {
        display: none;
    }

    .react-colorful__interactive:focus .react-colorful__pointer {
        transform: translate(-50%, -50%);
    }

    .react-colorful__interactive:active .react-colorful__pointer {
        width: 20px;
        height: 20px;
        border-width: 6px;
    }
`;
